import { Helmet } from 'react-helmet-async';
import { Build as BuildIcon } from '@mui/icons-material';
import { Box, Container, Link, Typography } from '@mui/material';

import { useWhatsAppClick } from '@/hooks/useWhatsAppClick';

function MaintenancePage() {
  const handleWhatsAppClick = useWhatsAppClick('maintenance_page', {
    includeJourney: false,
  });

  return (
    <>
      <Helmet>
        <title>Maintenance | DeepThink</title>
      </Helmet>
      <Container className="safe-mobile-all" maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <BuildIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom>
            System Maintenance
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Our server is currently undergoing maintenance. Please check back
            later. We apologize for any inconvenience.
          </Typography>
          <Link
            component="button"
            type="button"
            onClick={handleWhatsAppClick}
            sx={{
              mt: 2,
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'primary.main',
              fontWeight: 500,
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Need help? Contact us on WhatsApp (8012 7012)
          </Link>
        </Box>
      </Container>
    </>
  );
}

export default MaintenancePage;
